import { useState, useEffect } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress, Typography, TextField } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import PageService from '../../services/PageService'
import ApiService from '../../services/ApiService'

const EditFolderModal = ({
  dropdownElInfo,
  editFolderOpen,
  setEditFolderOpen,
  setTestCasesToggler
}) => {
  const [newName, setNewName] = useState('')
  const [newNameError, setNewNameError] = useState('')
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setNewName(dropdownElInfo.name)
  }, [dropdownElInfo.name])

  const handleCloseDeleteDialog = () => {
    setEditFolderOpen(false)
  }

  const handleNameChange = (e) => {
    setNewName(e.target.value)

    if (newNameError) {
      setNewNameError('')
    }
  }

  const handleDeleteFolder = async () => {
    const cycleId = dropdownElInfo?.cycleId
    const folderId = dropdownElInfo?.pageId || dropdownElInfo?.id
    if (!cycleId || !folderId) {
      setNewNameError('Cannot delete: missing cycle or folder id.')
      return
    }

    try {
      setDeleteLoading(true)
      await PageService.removeCyclePage(cycleId, folderId)
      setTestCasesToggler(prev => !prev)
      setEditFolderOpen(false)
      setNewName('')
    } catch (error) {
      const message =
        error?.response?.data?.error || error?.message || 'Failed to delete folder.'
      setNewNameError(message)
      console.log(error)
    } finally {
      setDeleteLoading(false)
    }
  }

  const handleUpdateFolder = async () => {
    if (!newName.trim()) {
      setNewNameError('Name is required.')
      return
    } else {
      setNewNameError('')
    }

    const folderId = dropdownElInfo?.pageId || dropdownElInfo?.id
    if (!folderId) {
      setNewNameError('Folder id is missing.')
      return
    }

    const folderType = dropdownElInfo?.folderType || 'page'

    try {
      setLoading(true)
      if (folderType === 'journey') {
        await ApiService.patch(`/journeys/${folderId}`, { name: newName.trim() })
      } else {
        await PageService.updatePage(folderId, { label: newName.trim() })
      }
      setTestCasesToggler(prev => !prev)
      setEditFolderOpen(false)
    } catch (error) {
      const message =
        error?.response?.data?.error || error?.message || 'Failed to update folder.'
      setNewNameError(message)
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={editFolderOpen} onClose={handleCloseDeleteDialog}>
      <Box className="editTestCaseFolderModal">
        <DialogTitle className="editTestCaseFolderModalTitle">
          Edit Folder
        </DialogTitle>
        <DialogContent className="editTestCaseFolderModalContent">
          <Typography variant='body1' mb={2}>
            Please edit the name of folder
          </Typography>
          <TextField
            label="Folder Name*"
            type="text"
            fullWidth
            variant="outlined"
            value={newName}
            onChange={handleNameChange}
            error={!!newNameError}
            helperText={newNameError + ' '}
          />
        </DialogContent>
        <DialogActions className="editTestCaseFolderModalActions">
          {deleteLoading ? (
            <LoadingButton
              loading
              className="deleteTestCaseFolderModalButton loadingButton"
              loadingIndicator={<CircularProgress color="error" size={16} />}
            />
          ) : (
            <Button className='deleteTestCaseFolderModalButton' onClick={handleDeleteFolder} color="error" variant="outlined">
              <DeleteOutlineOutlinedIcon color='error' />
            </Button>
          )}
          <Button className="editTestCaseFolderModalButton" onClick={handleCloseDeleteDialog} color="secondary" variant="outlined">
            CANCEL
          </Button>
          {loading ? (
            <LoadingButton
              loading
              className="editTestCaseFolderModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="editTestCaseFolderModalButton" onClick={handleUpdateFolder} color="secondary" variant="contained" autoFocus>
              SAVE
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default EditFolderModal
